var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "work-email-detail" },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _vm._m(0),
          _vm.hasPermission === 1
            ? [
                _c("div", { staticClass: "text" }, [_vm._v("基本信息")]),
                _c(
                  "div",
                  { staticClass: "forms" },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "form",
                        staticClass: "form",
                        attrs: {
                          inline: true,
                          model: _vm.form,
                          rules: _vm.rules,
                          size: "small",
                          "label-width": "96px",
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "工作邮箱", prop: "account" } },
                          [
                            _vm.permission.copy
                              ? _c(
                                  "div",
                                  { staticClass: "input-con" },
                                  [
                                    _c("el-input", {
                                      staticClass: "input",
                                      attrs: {
                                        placeholder: "请输入",
                                        maxlength: "256",
                                        clearable: "",
                                        disabled: !_vm.permission.edit,
                                      },
                                      model: {
                                        value: _vm.form.account,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "account", $$v)
                                        },
                                        expression: "form.account",
                                      },
                                    }),
                                    _vm.form.account
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "btn-copy",
                                            on: {
                                              click: function ($event) {
                                                return _vm.onCopy(
                                                  _vm.form.account
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("复制")]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass:
                                              "btn-copy btn-copy-dis",
                                          },
                                          [_vm._v("复制")]
                                        ),
                                  ],
                                  1
                                )
                              : _c("el-input", {
                                  staticClass: "input",
                                  attrs: {
                                    placeholder: "请输入",
                                    maxlength: "24",
                                    clearable: "",
                                    "show-word-limit": "",
                                    disabled: !_vm.permission.edit,
                                  },
                                  model: {
                                    value: _vm.form.account,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "account", $$v)
                                    },
                                    expression: "form.account",
                                  },
                                }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "邮箱密码", prop: "password" } },
                          [
                            _vm.permission.password
                              ? _c(
                                  "div",
                                  { staticClass: "input-con" },
                                  [
                                    _c("el-input", {
                                      staticStyle: { display: "none" },
                                      attrs: {
                                        type: "text",
                                        autocomplete: "username",
                                      },
                                    }),
                                    _vm.eye
                                      ? _c(
                                          "el-input",
                                          {
                                            staticClass: "input",
                                            attrs: {
                                              autocomplete: "new-password",
                                              placeholder: "请输入",
                                              maxlength: "20",
                                              type: _vm.eye
                                                ? "text"
                                                : "password",
                                              readonly: !_vm.permission.edit,
                                            },
                                            model: {
                                              value: _vm.form.password,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "password",
                                                  $$v
                                                )
                                              },
                                              expression: "form.password",
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "i-eye",
                                              attrs: { slot: "suffix" },
                                              on: { click: _vm.onEye },
                                              slot: "suffix",
                                            }),
                                          ]
                                        )
                                      : _c(
                                          "el-input",
                                          {
                                            staticClass: "input",
                                            attrs: {
                                              value: "******",
                                              type: "password",
                                              readonly: "",
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "i-eye-hide",
                                              attrs: { slot: "suffix" },
                                              on: { click: _vm.onEye },
                                              slot: "suffix",
                                            }),
                                          ]
                                        ),
                                    _vm.eye && _vm.permission.copy
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "btn-copy",
                                            on: {
                                              click: function ($event) {
                                                return _vm.onCopy(
                                                  _vm.form.password
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("复制")]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass:
                                              "btn-copy btn-copy-dis",
                                          },
                                          [_vm._v("复制")]
                                        ),
                                  ],
                                  1
                                )
                              : _c("el-input", {
                                  staticClass: "input",
                                  attrs: {
                                    value: "******",
                                    type: "password",
                                    disabled: true,
                                  },
                                }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "t-label",
                            attrs: { label: "邮箱实名人" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "custom-label" },
                                        [
                                          _vm._v("邮箱"),
                                          _c("br"),
                                          _vm._v("实名人"),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              2789090330
                            ),
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "204px" },
                              attrs: {
                                placeholder: "请输入",
                                clearable: "",
                                maxlength: "30",
                                type: "textarea",
                                rows: "3",
                                "show-word-limit": "",
                                disabled: !_vm.permission.edit,
                              },
                              model: {
                                value: _vm.form.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "name", $$v)
                                },
                                expression: "form.name",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "label-star",
                            attrs: {
                              label: "邮箱 绑定手机号",
                              prop: "hasPhone",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "custom-label" },
                                        [
                                          _vm._v("是否绑定"),
                                          _c("br"),
                                          _vm._v("手机号"),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              2819459176
                            ),
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                staticClass: "el-input",
                                attrs: { disabled: !_vm.permission.edit },
                                model: {
                                  value: _vm.form.hasPhone,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "hasPhone", $$v)
                                  },
                                  expression: "form.hasPhone",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v("是"),
                                ]),
                                _c("el-radio", { attrs: { label: 0 } }, [
                                  _vm._v("否"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.form.hasPhone == 1
                          ? [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "邮箱 绑定手机号",
                                    prop: "phone",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "custom-label" },
                                              [
                                                _vm._v("邮箱"),
                                                _c("br"),
                                                _vm._v("绑定手机号"),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    2153458270
                                  ),
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入",
                                      maxlength: "11",
                                      clearable: "",
                                      "show-word-limit": "",
                                      disabled: !_vm.permission.edit,
                                    },
                                    on: { input: _vm.checkPhone },
                                    model: {
                                      value: _vm.form.phone,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "phone", $$v)
                                      },
                                      expression: "form.phone",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "t-label",
                                  attrs: { label: "绑定手机号所属员工" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "custom-label" },
                                              [
                                                _vm._v("绑定手机号"),
                                                _c("br"),
                                                _vm._v("所属员工"),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    1965034146
                                  ),
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "204px" },
                                    attrs: {
                                      placeholder: "自动识别",
                                      disabled: "",
                                    },
                                    model: {
                                      value: _vm.accountName,
                                      callback: function ($$v) {
                                        _vm.accountName = $$v
                                      },
                                      expression: "accountName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "t-label",
                            attrs: { label: "邮箱备注", prop: "remarks" },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "204px" },
                              attrs: {
                                placeholder: "请输入",
                                clearable: "",
                                maxlength: "64",
                                type: "textarea",
                                rows: "3",
                                "show-word-limit": "",
                                disabled: !_vm.permission.edit,
                              },
                              model: {
                                value: _vm.form.remarks,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "remarks", $$v)
                                },
                                expression: "form.remarks",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                    _c("div", { staticClass: "line" }),
                    _c("p", [_vm._v("更多信息")]),
                    _c(
                      "el-form",
                      {
                        staticClass: "form-list",
                        attrs: {
                          inline: true,
                          size: "small",
                          "label-width": "96px",
                        },
                      },
                      [
                        _c("el-form-item", { attrs: { label: "创建时间：" } }, [
                          _c("div", { staticClass: "con" }, [
                            _vm._v(_vm._s(_vm.form.createdTime || "-")),
                          ]),
                        ]),
                        _c("el-form-item", { attrs: { label: "创建人：" } }, [
                          _c("div", { staticClass: "con" }, [
                            _vm._v(_vm._s(_vm.form.createdByName || "-")),
                          ]),
                        ]),
                        _c("el-form-item", { attrs: { label: "邮箱状态：" } }, [
                          _c("div", { staticClass: "con" }, [
                            _vm.form.statusLabel
                              ? _c(
                                  "span",
                                  {
                                    class:
                                      "icon-status icon-status-" +
                                      _vm.form.status,
                                  },
                                  [_vm._v(" " + _vm._s(_vm.form.statusLabel))]
                                )
                              : _vm._e(),
                          ]),
                        ]),
                        _c(
                          "el-form-item",
                          { attrs: { label: "最后归属人：" } },
                          [
                            _c("div", { staticClass: "con" }, [
                              _vm._v(_vm._s(_vm.form.ownerUserName || "-")),
                            ]),
                          ]
                        ),
                        _c("el-form-item", { attrs: { label: "更新时间：" } }, [
                          _c("div", { staticClass: "con" }, [
                            _vm._v(_vm._s(_vm.form.updatedTime || "-")),
                          ]),
                        ]),
                        _c(
                          "el-form-item",
                          { attrs: { label: "最近更新人：" } },
                          [
                            _c("div", { staticClass: "con" }, [
                              _vm._v(_vm._s(_vm.form.updatedByName || "-")),
                            ]),
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "最后归属部门：" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "custom-label" },
                                        [
                                          _vm._v("最后   "),
                                          _c("br"),
                                          _vm._v("归属部门："),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              151213012
                            ),
                          },
                          [
                            _c("div", { staticClass: "con" }, [
                              _vm._v(_vm._s(_vm.form.ownerDeptName || "-")),
                            ]),
                          ]
                        ),
                        _vm.form.status == 3 && _vm.form.cancelReason
                          ? _c(
                              "el-form-item",
                              { attrs: { label: "注销原因：" } },
                              [
                                _c("div", { staticClass: "con" }, [
                                  _vm._v(_vm._s(_vm.form.cancelReason)),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm.permission.history
                          ? _c(
                              "el-form-item",
                              { attrs: { label: "历史记录：" } },
                              [
                                _c(
                                  "div",
                                  { staticClass: "con" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "btn-look",
                                        attrs: {
                                          type: "primary",
                                          plain: "",
                                          size: "mini",
                                        },
                                        on: { click: _vm.onHistory },
                                      },
                                      [_vm._v("查看")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm.hasPermission === 0
            ? _c("div", { staticClass: "no-permission" }, [
                _c("div", { staticClass: "pic" }),
                _c("div", { staticClass: "word" }, [
                  _vm._v("抱歉，您缺少权限"),
                ]),
              ])
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "footer",
              class: [_vm.isCollapsed ? "footer-collapsed" : ""],
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "info", plain: "" },
                  on: { click: _vm.onBack },
                },
                [_vm._v("返回")]
              ),
              _vm.btnShow
                ? [
                    _vm.permission.delete
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "danger", loading: _vm.btnDelete },
                            on: { click: _vm.onDelete },
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e(),
                    _vm.permission.cancel
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "danger", loading: _vm.btnCancel },
                            on: { click: _vm.onCancel },
                          },
                          [_vm._v("注销账号")]
                        )
                      : _vm._e(),
                    _vm.permission.revoke
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "info",
                              plain: "",
                              loading: _vm.btnRevoke,
                            },
                            on: { click: _vm.onRevoke },
                          },
                          [_vm._v("撤销")]
                        )
                      : _vm._e(),
                    _vm.permission.transfer
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              loading: _vm.btnTransfer,
                            },
                            on: { click: _vm.onTransfer },
                          },
                          [_vm._v("转移")]
                        )
                      : _vm._e(),
                    _vm.permission.edit
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary", loading: _vm.btnSave },
                            on: { click: _vm.onSave },
                          },
                          [_vm._v("保存")]
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        2
      ),
      _c("org-picker", {
        ref: "orgPicker",
        attrs: { title: "转移", multiple: false },
        on: { ok: _vm.selected },
      }),
      _c("pop-report", {
        ref: "popReport",
        attrs: { reportList: _vm.reportList },
      }),
      _c("pop-cancel", {
        ref: "popCancel",
        attrs: { title: "是否确认注销该工作邮箱？" },
        on: { setCancel: _vm.setCancel },
      }),
      _c("pop-revoke", {
        ref: "popRevoke",
        attrs: { title: "是否确认撤销该工作邮箱？" },
        on: { setRevoke: _vm.setRevoke },
      }),
      _c("pop-delete", {
        ref: "popDelete",
        attrs: { title: "是否确认删除？" },
        on: { setDelete: _vm.setDelete },
      }),
      _c("pop-approve", {
        ref: "popApprove",
        attrs: { title: "审核" },
        on: { setApprove: _vm.setApprove },
      }),
      _c("pop-history", { ref: "popHistory", attrs: { title: "历史记录" } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "data-title" }, [
      _c("div", { staticClass: "title-name" }, [_vm._v("查看/编辑工作邮箱")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }